<template>
  <b-container fluid class="animated fadeIn">
    <div v-show="errorText !== ''" class="alert alert-danger" role="alert" dismissible @dismised="errorText = ''">
      {{errorText}}
    </div>
    <div v-show="success" class="alert alert-success" role="alert" dismissible @dismised="success=false">
      La acción fue completada con éxito
    </div>

    <b-row>
      <b-col>
        <button class="btn btn-primary float-right mb-3 mr-2" @click="openCarrierModal(selectedCarrier)">Crear transportadora</button>
        <button class="btn btn-primary float-right mb-3 mr-2" v-b-toggle.collapse2 @click="showFilters = !showFilters">
          <i class="fa" :class="{'fa-times': showFilters, 'fa-filter': !showFilters}" />Filtros
        </button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
          <b-collapse id="collapse2">
            <b-card class="filters mt-3 p-3">
              <b-form-group horizontal
                :label-cols="2"
                breakpoint="md"
                label="Nombre"
                label-for="nameLabelFormater">
                <b-form-input
                  type="text"
                  id="nameLabelFormater"
                  v-model="carrierFilterRules.text"
                  @keydown.native="textInputValidation">
                </b-form-input>
              </b-form-group>
              <b-form-group horizontal
                :label-cols="2"
                breakpoint="md"
                label="Tipo SLA"
                label-for="slaLabelFormater">
                <b-form-select v-model="carrierFilterRules.slaType"
                  :options="slaFilterOptions"/>
              </b-form-group>
              <b-row>
                <b-col>
                  <button class="btn btn-primary float-right" :disabled='loading' @click="$refs.mainTable.refresh()">Filtrar</button>
                  <button class="btn btn-primary float-right mr-2" :disabled='loading' @click="resetFilters">Mostrar Todos</button>
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card header-bg-variant="primary" border-variant="primary" header="Lista de transportadoras">
          <moon-loader :loading="loading" color="#000" size="30px"></moon-loader>
          <b-table
            v-show="!loading"
            id="mainTable"
            ref="mainTable"
            responsive=true
            stacked="xl"
            empty-text="No hay transportadoras para mostrar"
            empty-filtered-text="No hay transportadoras para mostrar"
            show-empty
            striped
            hover
            foot-clone
            :items="itemProvider"
            :fields="isAdmin ? fieldsAdmin : fields"
            :filter="filter"
            @row-clicked="openCarrierModal">
              <template slot="actions" slot-scope="row">
                <b-button variant="primary" size="sm" @click.stop="showSellerModal(row)">Editar</b-button>
              </template>
              <template slot="isActive" slot-scope="row">
                {{row.item.isActive ? 'Activa' : 'Inactiva'}}
              </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      header-bg-variant="primary"
      ref="carrierInfo"
      centered
      :title="selectedCarrier.id ? 'Guardar transportadora' : 'Crear transportadora'"
      size="lg"
      @hide="resetModal"
      >
      <b-container fluid>
        <b-row>
          <b-col md="12">
            <carrier-form :value="selectedCarrier" :organizationOptions="organizationOptions"/>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer" class="w-100">
        <b-row>
          <b-col class="px-4">
            <b-button class="mb-2 mx-1 float-right" @click="$refs.carrierInfo.hide()">Cancelar</b-button>
            <b-button class="mb-2 mx-1 float-right"
              :disabled="disableSave"
              @click="handleSave">{{selectedCarrier.id ? 'Guardar' : 'Crear'}}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal
      ref="sellerModal"
      id="sellerModal"
      header-bg-variant="primary"
      centered
      title="Editar Sellers"
      size="lg"
      :ok-disabled="sellersItems &&  Object.keys(shippingsExcluded).find(key => shippingsExcluded[key] === selectedEditCarrier.item.name) ? sellersItems.find(o => !o.integrationType) ? true: false : false"
      @hide="resetModal"
      >
      <b-row>
        <b-col>
          <b-alert :show="errorTextModal !== ''" fade dismissible variant="danger">{{errorTextModal}}</b-alert>
          <b-alert :show="successTextModal !== ''" variant="success" dismissible>{{successTextModal}}</b-alert>
          <moon-loader :loading="loadingModal" color="#000" size="30px"></moon-loader>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col md="8">
          <b-form-group
            id="inputSellersGroup"
            horizontal
            :label-cols="2"
            breakpoint="md"
            label="Sellers"
            label-for="inputSellers">
            <autocomplete
              id="inputSellers"
              name="inputSellers"
              :maxElements="1"
              :provider="searchOrganization"
              :disabled="loading"
              v-model="selSeller">
            </autocomplete>
          </b-form-group>
        </b-col>
        <b-col>
          <b-button class="ml-auto addSpec primary" @click="addSeller()" :disabled="selSeller.length === 0">Agregar Seller</b-button>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-md-auto">
          <b-pagination :total-rows="totalRowsSeller" :per-page="filterRules.size" v-model="filterRules.from" class="mb-3" />
        </b-col>
        <b-col class="col-md-auto per-page">
          <b-form-group id="perPage" horizontal >
            <b-form-select :options="pageOptions" v-model="filterRules.size" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        id="sellersTable"
        ref="sellersTable"
        show-empty
        striped
        hover
        :sort-by.sync="filterRules.sortBy"
        :sort-desc.sync="filterRules.sortOrder"
        :per-page="filterRules.size"
        :current-page="filterRules.from"
        :items="sellerProvider"
        :fields="fieldsSeller"
        :filter="filter"
        :fixed=true
        small
        responsive=true
        stacked="xl"
        empty-text="No hay sellers para mostrar"
        empty-filtered-text="No hay sellers para mostrar">
          <template slot="guide"  slot-scope="row" >
            <b-form-group
                class="my-1 radio-guia"
                v-if="Object.keys(shippingsExcluded).find(key => shippingsExcluded[key] === selectedEditCarrier.item.name)"
                :label-cols="6"
                :invalid-feedback="!row.item.integrationType ? 'Ingrese un tipo de guía' : ''"
                :state="row.item.integrationType"
              >
              <b-form-radio-group
                v-model="row.item.integrationType"
                :value="row.item.integrationType"
                :options="guiaOptions"
                @change="onChangeSeller(row.item, $event)"
                >
              </b-form-radio-group>
            </b-form-group>
          </template>
          <template slot="actions"  slot-scope="row" >
            <b-button @click="removeSeller(row.item)"><i class="fa fa-trash" aria-hidden="true"></i></b-button>
          </template>
      </b-table>
    </b-modal>
  </b-container>
</template>
<script>

import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import { CarrierServiceMixin } from '@/mixims/CarrierServiceMixin'
import { OrganizationService } from '@/mixims/AdminServiceMixin'
import { ValidationsMixim } from '@/mixims/ValidationsMixim'
import OrganizationsCheckbox from '@/components/user/OrganizationsCheckbox'
import CarrierForm from './CarrierForm'
import appConfig from '@/config/applicationConfig.js'
import autocomplete from '@/components/common/vue-autocomplete'

export default {
  name: 'carrier-list',
  components: { MoonLoader, OrganizationsCheckbox, CarrierForm, autocomplete },
  mixins: [CarrierServiceMixin, OrganizationService, ValidationsMixim],
  data () {
    return {
      success: null,
      errorText: '',
      errorTextModal: '',
      successTextModal: '',
      loading: true,
      loadingModal: false,
      showFilters: false,
      isAdmin: this.$store.getters.isAdmin,
      fields: [
        { key: 'slaType', label: 'Tipo SLA', 'class': 'text-left', sortable: false },
        { key: 'name', label: 'Nombre', 'class': 'text-left', sortable: false },
        { key: 'isActive', label: 'Estado', 'class': 'text-left', sortable: false }
      ],
      fieldsAdmin: [
        { key: 'slaType', label: 'Tipo SLA', 'class': 'text-left', sortable: false },
        { key: 'name', label: 'Nombre', 'class': 'text-left', sortable: false },
        { key: 'actions', label: 'Seller', 'class': 'text-left', sortable: false }
      ],
      selectedCarrier: {
        name: '',
        slaType: null,
        selectedCarrierBase: null,
        isActive: false,
        factorCubicWeight: null

      },
      carrierFilterRules: {
        text: '',
        slaType: null
      },
      slaFilterOptions: [{ value: null, text: 'Todos los tipos de SLA' }, ...appConfig.SLA_LIST],
      organizationOptions: this.$store.state.user_data.sellers,
      selSeller: [],
      filterRules: {
        sortBy: 'name',
        sortOrder: false,
        size: 10,
        from: 0,
        text: ''
      },
      pageOptions: [ 10, 15, 25, 50, 100 ],
      fieldsSeller: [
        { key: 'name', label: 'Cuenta', 'class': 'text-left', sortable: true },
        { key: 'actions', label: ' ', 'class': 'text-right' }
      ],
      totalRowsSeller: 0,
      selectedEditCarrier: {},
      guiaOptions: [
        { text: 'Guía manual', value: 'MANUAL' },
        { text: 'Guía automática', value: 'AUTOMATIC' }
      ],
      shippingsExcluded: appConfig.SHIPPING_EXCLUDED,
      sellersItems: null
    }
  },
  methods: {
    resetFilters () {
      this.carrierFilterRules = {
        text: '',
        slaType: null
      }
      this.$refs.mainTable.refresh()
    },
    filter () {
      return this.carrierFilterRules
    },
    addIfNotPresent (list, item) {
      if (!list.includes(item)) list.push(item)
    },
    handleSave () {
      if (this.selectedCarrier.id) {
        this.updateCarrier(this.selectedCarrier).then(() => {
          this.success = true
          this.$refs.mainTable.refresh()
          this.$refs.carrierInfo.hide()
        }).catch(er => {
          this.errorText = er.body.message || 'Ocurrió un error al modificar la transportadora'
        })
      } else {
        this.createCarrier(this.selectedCarrier).then(() => {
          this.success = true
          this.$refs.mainTable.refresh()
          this.$refs.carrierInfo.hide()
        }).catch(er => {
          this.errorText = er.body.message || 'Ocurrió un error al crear la transportadora'
        })
      }
    },
    resetModal () {
      this.selectedCarrier = {
        name: '',
        slaType: null,
        selectedCarrierBase: null
      }
    },
    openCarrierModal (carrier) {
      this.selectedCarrier = {...carrier}
      /* Get the carrier base name from the carrier name */
      this.selectedCarrier.selectedCarrierBase = this.selectedCarrier.name.split('_')[1] ? this.selectedCarrier.name.split('_')[1] : null

      if (this.$store.state.user_data.organizations.length === 1) this.selectedCarrier.accountName = this.$store.state.user_data.organizations[0].accountName
      this.$refs.carrierInfo.show()
    },
    itemProvider (ctx) {
      this.loading = true
      let filter = ctx.filter()
      return this.getCarriers(filter).then(
        response => {
          this.loading = false
          this.$store.dispatch('setCarrierData', response.body)
          return response.body
        },
        error => {
          this.errorText = error.body.message || 'Error obteniendo el listado de transportadoras'
          this.loading = false
          return []
        }
      )
    },
    showSellerModal (item) {
      this.loadingModal = false
      this.errorTextModal = ''
      this.successTextModal = ''
      this.selectedEditCarrier = item
      // if (this.selectedEditCarrier.item.name === this.shippingExcluded || this.selectedEditCarrier.item.name === this.shippingExcludedTest) {
      if (Object.keys(this.shippingsExcluded).find(key => this.shippingsExcluded[key] === this.selectedEditCarrier.item.name)) {
        this.fieldsSeller = [
          { key: 'name', label: 'Cuenta', 'class': 'text-left', sortable: true },
          { key: 'guide', label: ' ', 'class': 'guide-width' },
          { key: 'actions', label: ' ', 'class': 'text-right' }
        ]
      }
      this.$refs.sellersTable.refresh()
      this.selSeller.splice(0, this.selSeller.length)
      this.$refs.sellerModal.show()
    },
    selectedSeller (seller) {
      this.selSeller = seller
    },
    addSeller () {
      this.loadingModal = true
      this.successTextModal = ''
      this.errorTextModal = ''
      let carrierSeller = {
        'accountName': this.selSeller[0].accountName,
        'carrierId': this.selectedEditCarrier.item.id,
        'isActive': true
      }
      if (Object.keys(this.shippingsExcluded).find(key => this.shippingsExcluded[key] === this.selectedEditCarrier.item.name)) {
        if (!carrierSeller.integrationType) {
          carrierSeller.integrationType = 'MANUAL'
        }
      }
      this.addSellerToCarrier(this.selectedEditCarrier.item.id, carrierSeller).then(
        response => {
          this.loadingModal = false
          this.successTextModal = 'El seller fue agregado con exito'
          this.selSeller.splice(0, this.selSeller.length)
          this.$refs.sellersTable.refresh()
        },
        () => {
          this.selSeller.splice(0, this.selSeller.length)
          this.loadingModal = false
          this.errorTextModal = 'Error agregando el seller'
        }
      )
    },
    onChangeSeller (item, option) {
      const intType = option
      this.loadingModal = true
      this.successTextModal = ''
      this.errorTextModal = ''
      let carrierSeller = {
        'accountName': item.accountName,
        'carrierId': this.selectedEditCarrier.item.id,
        'isActive': true,
        'integrationType': intType
      }
      this.addSellerToCarrier(this.selectedEditCarrier.item.id, carrierSeller).then(
        response => {
          this.loadingModal = false
          this.successTextModal = 'El seller fue modificado con exito'
          this.$refs.sellersTable.refresh()
        },
        () => {
          this.loadingModal = false
          this.errorTextModal = 'Error al modificar el seller'
        }
      )
    },
    sellerProvider (tableFilter) {
      this.loadingModal = true
      if (!this.selectedEditCarrier.item) return []
      return this.getSellersFromCarrier(this.selectedEditCarrier.item.id, tableFilter).then(
        response => {
          this.loadingModal = false
          this.sellersItems = response.body
          return response.body
        },
        () => {
          this.loadingModal = false
          this.errorTextModal = 'Error obteniendo el listado de sellers'
          return []
        }
      )
    },
    removeSeller (carrierSeller) {
      this.loadingModal = true
      this.successTextModal = ''
      this.errorTextModal = ''
      this.delSellerToCarrier(this.selectedEditCarrier.item.id, carrierSeller.id).then(
        response => {
          this.loadingModal = false
          this.selSeller.splice(0, this.selSeller.length)
          this.successTextModal = 'El seller fue eliminado con exito'
          this.$refs.sellersTable.refresh()
        },
        () => {
          this.loadingModal = false
          this.selSeller.splice(0, this.selSeller.length)
          this.errorTextModal = 'Error eliminando el sellers'
        }
      )
    }
  },
  computed: {
    filterState () {
      return {
        name: Boolean(this.carrierFilterRules.text),
        slaType: Boolean(this.carrierFilterRules.slaType)
      }
    },
    disableSave () {
      return Object.values(this.state).includes(false)
    },
    state () {
      return {
        name: this.isValidText(this.selectedCarrier.name, true),
        slaType: this.isValidText(this.selectedCarrier.slaType, true),
        factorCubicWeight: this.isValidFloat(this.selectedCarrier.factorCubicWeight, false, true)
      }
    }
  }
}
</script>
<style lang="scss">
  .multiselect {
    &.multiselect--active {
      z-index: 3 !important;
    }
  }
  .guide-width {
    width: 278px !important;
  }
  .radio-guia {
    .invalid-feedback {
        display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/carrier/CarrierList.vue